const DISMISSAL_PREFIX = "elsa:feedback-widget:dismissed:";
export const FEEDBACK_WIDGET_RESET_EVENT = "elsa:feedback-widget:reset";
export const FEEDBACK_FORM_OPEN_EVENT = "elsa:feedback-form:open";

export function requestFeedbackForm(userId: unknown) {
  const id = Number(userId);
  if (Number.isSafeInteger(id) && id > 0 && typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(FEEDBACK_FORM_OPEN_EVENT, { detail: { userId: id } }));
  }
}

function dismissalKey(userId: unknown) {
  const id = Number(userId);
  return Number.isSafeInteger(id) && id > 0 ? `${DISMISSAL_PREFIX}${id}` : null;
}

export function isFeedbackWidgetDismissed(userId: unknown) {
  const key = dismissalKey(userId);
  try {
    return Boolean(key && window.sessionStorage.getItem(key) === "1");
  } catch (_error) {
    return false;
  }
}

export function dismissFeedbackWidget(userId: unknown) {
  const key = dismissalKey(userId);
  if (!key) return;
  try {
    window.sessionStorage.setItem(key, "1");
  } catch (_error) {
    // Le widget conserve la fermeture en mémoire si le stockage est bloqué.
  }
}

// Appelé à la connexion explicite et à la déconnexion, jamais lors du
// renouvellement automatique du token ni d'un rechargement de page.
export function clearFeedbackWidgetDismissals() {
  try {
    const storage = window.sessionStorage;
    for (let index = storage.length - 1; index >= 0; index--) {
      const key = storage.key(index);
      if (key?.startsWith(DISMISSAL_PREFIX)) storage.removeItem(key);
    }
  } catch (_error) {
    // Le signal réinitialise aussi les widgets encore montés sans stockage.
  }
  if (typeof window !== "undefined") window.dispatchEvent(new Event(FEEDBACK_WIDGET_RESET_EVENT));
}
